import FenceImageBox from './FenceImageBox';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@mui/material';
import Text from './Text';

const RenderOptionImages = ({
  data,
  allowSecondClick,
  handleDropdownChange,
  lastClickTime,
  setLastClickTime,
  handleDropdownChangeMaterial,
  CalcKey
}) => {
  const recommendedImgs = data?.filter(
    (img) => img['1stRecommended'] == 1 || img['2ndRecommended'] == 1
  );

  const otherImgs = data?.filter((img) => img['1stRecommended'] != 1 && img['2ndRecommended'] != 1);

  let recommendedImgsHTML;

  if (recommendedImgs?.length > 0)
    recommendedImgsHTML = recommendedImgs?.map((imgData, index) => (
      <FenceImageBox
        key={index}
        imgData={imgData}
        handleChange={() => {
          !allowSecondClick(lastClickTime, setLastClickTime) &&
            handleDropdownChange(CalcKey, imgData.id, data);
        }}
        handleMaterials={(value, materials) => {
          !allowSecondClick(lastClickTime, setLastClickTime) &&
            handleDropdownChangeMaterial(CalcKey + 1, value, materials);
        }}
      />
    ));

  const otherImgsHTML = otherImgs?.map((imgData, index) => (
    <FenceImageBox
      key={index}
      imgData={imgData}
      handleChange={() => {
        !allowSecondClick(lastClickTime, setLastClickTime) &&
          handleDropdownChange(CalcKey, imgData.id, data);
      }}
      handleMaterials={(value, materials) => {
        !allowSecondClick(lastClickTime, setLastClickTime) &&
          handleDropdownChangeMaterial(CalcKey + 1, value, materials);
      }}
    />
  ));

  if (recommendedImgsHTML?.length > 0) {
    const ImgsHTML = (
      <Grid
        item
        spacing={4}
        display="flex"
        sx={{
          minHeight: '75vh',
          backgroundColor: 'white',
          flexWrap: 'wrap',
          width: '100%',
          alignContent: 'flex-start'
        }}>
        {recommendedImgsHTML?.length > 0 && (
          <>
            <Grid xs={12} sx={{ mt: 1, ml: 0.75 }}>
              <Text sx={{ fontSize: 24, color: 'grey' }}>Recommended</Text>
            </Grid>
            {recommendedImgsHTML}
            <Grid xs={12} sx={{ mt: 1, ml: 0.75 }}>
              <Divider thickness={4} sx={{ borderBottomWidth: 5, borderColor: 'grey' }} />
            </Grid>
          </>
        )}
        {otherImgsHTML}
      </Grid>
    );

    return ImgsHTML;
  } else return otherImgsHTML;
};

RenderOptionImages.propTypes = {
  data: PropTypes.array,
  allowSecondClick: PropTypes.func,
  handleDropdownChange: PropTypes.func,
  lastClickTime: PropTypes.number,
  setLastClickTime: PropTypes.func,
  handleDropdownChangeMaterial: PropTypes.func,
  CalcKey: PropTypes.number
};

export default RenderOptionImages;
